var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPostponed = function SvgPostponed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#B2C9DE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12.066 16.9a4.9 4.9 0 1 1 0-9.8 4.9 4.9 0 0 1 0 9.8Zm-6.3-4.9a6.3 6.3 0 1 1 12.6 0 6.3 6.3 0 0 1-12.6 0Zm7-2.8a.7.7 0 1 0-1.4 0V12a.7.7 0 0 0 .7.7h2.8a.7.7 0 1 0 0-1.4h-2.1V9.2Z",
    clipRule: "evenodd"
  })));
};
export default SvgPostponed;